import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CallToAction = () => {
  return (
    <section className="py-16 lg:py-24">
      <div className="max-w-4xl mx-auto text-center bg-card border border-border rounded-3xl p-10 shadow-brand-sm">
        <h3 className="text-2xl font-bold mb-4">Interested in working together?</h3>
        <p className="text-muted-foreground mb-6">I'm available for freelance projects and new full-time opportunities. Let's build something great.</p>
        <div className="flex justify-center gap-4">
          <Button variant="default" size="lg" iconName="Mail" iconPosition="left" className="bg-gradient-brand">
            Contact Me
          </Button>
          <Button variant="outline" size="lg" iconName="Download" iconPosition="left">
            Download Resume
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
